import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { ValueStub } from 'constants/data';
import { COMMON_DATE_FORMAT, SHORT_TIME_FORMAT } from 'constants/date';

import { dateTimeCellStyles } from './DateTimeCell.styles';

const DateTimeCell = ({ value }) => {
  if (!value) {
    return <Typography variant="regular16">{ValueStub.ALTERNATE}</Typography>;
  }

  const date = dayjs(value);

  return (
    <Box sx={dateTimeCellStyles}>
      <Typography variant="regular16">{date.format(COMMON_DATE_FORMAT)}</Typography>
      <Typography color="textSecondary" variant="regular16">
        {date.format(SHORT_TIME_FORMAT)}
      </Typography>
    </Box>
  );
};

DateTimeCell.propTypes = {
  value: PropTypes.string,
};

export default memo(DateTimeCell);
